<script>
  import CommentDialog from './comment-dialog'

  export default {
    name: 'kye-field-comment',
    props: {
      value: [String, Number],
      isRequest: { // 是否请求接口判断权限
        type: Boolean,
        default: false,
      },
      option: {
        type: Object,
        default: () => ({
          employeeIds: [], // 可评价人
          gradedTime: '', // 截止时间
          authCode: '', // 权限编码
          bizCode: '', // 业务数据标识
          bizId: '', // 业务数据id
          employeeId: '' // 被评价人id
        })
      },
    },
      components: {
      CommentDialog
    },
    data () {
      return {
        status: false,
        isSaved: false
      }
    },
    watch: {
      option: {
        handler () {
          this.checkAuth()
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      handleClick (value) {
        if (!this.status) {
          return
        }
        this.$refs.commentDialog.init({
          authCode: this.option.authCode,
          bizCode: this.option.bizCode,
          bizId: this.option.bizId,
          employeeId: this.option.employeeId
        })
        this.$refs.commentDialog.showDialog()
      },
      async checkAuth () {
        // 必填字段
        if (!this.option.authCode || !this.option.bizCode || !this.option.bizId || !this.option.employeeId) {
          this.status = false
          return
        }
        if (this.isRequest) {
          try {
            let res = await this.$http('fdb.grade.check', {
              permissionCode: this.option.authCode,
              bizCode: this.option.bizCode,
              bizId: this.option.bizId,
              employeeId: this.option.employeeId
            }, { cancel: true, appkey: '50178' })
            this.status = res
          } catch (err) {
            this.status = false
          }
        } else {
          // 1、评价人列表不存在
          // 2、评价人列表为空
          // 3、当前人已评价
          if (!this.option.employeeIds || (this.option.employeeIds && this.option.employeeIds.length === 0) || this.isSaved) {
            this.status = false
            return
          }
          if (this.option.employeeIds.indexOf(this.option.employeeId) > -1) {
            this.status = true
            // 超过截止时间
            if (this.option.gradedTime && new Date(this.option.gradedTime).getTime() < new Date().getTime()) {
              this.status = false
            }
          }
        }
      },
      save () {
        this.checkAuth()
        this.isSaved = true
        this.$emit('save')
      }
    },
    render (h) {
      let title = this.$slots && this.$slots.default && this.$slots.default[0] && this.$slots.default[0].text
      let icon = require('./icon.svg')
      let iconGray = require('./icon-gray.svg')
      title = this.value || title || ''
      if (title && typeof title === 'string') {
        title = title.trim()
      }
      return (
        <div class="kye-field-comment">
          <span class={`kye-field-content kye-field-comment__content`} title={ title }>
            <label>{ this.value !== undefined ? this.value : this.$slots.default }</label>
          </span>
          <div class={`kye-field-comment__icon ${this.status ? '' : 'kye-field-comment__icon-disabled'}`} onClick={() => this.handleClick(title)}>
            <img src={`${this.status ? icon : iconGray}`} />
            <span>评价</span>
          </div>
          <comment-dialog ref="commentDialog" onClose={() => this.$emit('close')} onSave={() => this.save()} />
        </div>
      )
    }
  }
</script>

<style lang="scss">
  .kye-field-comment {
    display: flex;
    justify-content: space-between;
    width: 100%;
    &__content {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      flex: 1;
    }
    &__icon {
      width: 56px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
      color: #ff9300;
      cursor: pointer;
      border: #ff9300 1px solid;
      background-color: #fff9ed;
      height: 29px;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      img {
        width: 12px;
        height: 12px;
      }
      &-disabled {
        color: #aaaaaa;
        border: #d2d2d6 1px solid;
        background-color: #f5f5f5;
        // display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-field-comment/index.vue